import { jsx as _jsx } from "react/jsx-runtime";
import { Bold, Italic, Underline } from './Texts';
import { Title, Small } from './Texts';
export function textComponentRegister(type) {
    switch (type) {
        case 'title':
            return renderTitle;
        case 'small':
            return renderSmall;
        case 'bold':
            return renderBold;
        case 'italic':
            return renderItalic;
        case 'underline':
            return renderUnderline;
    }
}
export function renderTitle(component, index, renderChildrenFunction) {
    return _jsx(Title, { children: renderChildrenFunction && renderChildrenFunction(component) });
}
export function renderSmall(component, index, renderChildrenFunction) {
    return _jsx(Small, { children: renderChildrenFunction && renderChildrenFunction(component) });
}
export function renderBold(component, index, renderChildrenFunction) {
    return _jsx(Bold, { children: renderChildrenFunction && renderChildrenFunction(component) });
}
export function renderItalic(component, index, renderChildrenFunction) {
    return _jsx(Italic, { children: renderChildrenFunction && renderChildrenFunction(component) });
}
export function renderUnderline(component, index, renderChildrenFunction) {
    return _jsx(Underline, { children: renderChildrenFunction && renderChildrenFunction(component) });
}
